import { writable } from 'svelte/store';
export const toastStore = writable([]);
export const addToast = (type, message, persistent = false) => {
    const id = Date.now() + Math.random();
    toastStore.update((toasts) => [...toasts, { id, type, message, persistent }]);
    if (!persistent) {
        setTimeout(() => {
            toastStore.update((toasts) => toasts.filter((toast) => toast.id !== id));
        }, 5000);
    }
};
export const removeToast = (id) => {
    toastStore.update((toasts) => toasts.filter((toast) => toast.id !== id));
};
